import JobDetailPage from "@app/pages/queue/job-detail-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/queue/$jobId")({
  head: ({ params }) => pageHead(`Job #${params.jobId}`),
  component: JobDetailRoute,
});

// No loader, for the same reason /queue has none: a loader only runs on a
// client-side navigation here, and a permalink exists precisely to be opened
// cold — from a bookmark, a support thread, or a link somebody was sent.
function JobDetailRoute() {
  const { jobId } = Route.useParams();
  const parsed = Number(jobId);

  if (!Number.isInteger(parsed)) {
    return (
      <div className="mx-auto max-w-3xl p-6 text-sm text-gray-600">
        <h1 className="mb-2 text-xl font-bold">Job</h1>
        <p>“{jobId}” is not a job number.</p>
      </div>
    );
  }

  return (
    <ErrorBoundary
      fallback={
        <div className="mx-auto max-w-3xl space-y-3 p-6">
          <h1 className="text-xl font-bold">Job #{jobId}</h1>
          <p className="text-sm text-gray-600">
            Could not read this job just now. Nothing has been lost — the record
            is never deleted.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded border border-gray-200 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            Try again
          </button>
        </div>
      }
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading the job…</div>}
      >
        <JobDetailPage jobId={parsed} />
      </Suspense>
    </ErrorBoundary>
  );
}
